import { render, staticRenderFns } from "./PatientPeriodVisit.vue?vue&type=template&id=9e6d6bd6&scoped=true"
import script from "./PatientPeriodVisit.vue?vue&type=script&lang=js"
export * from "./PatientPeriodVisit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e6d6bd6",
  null
  
)

export default component.exports